import * as React from 'react';
import { observer } from 'mobx-react';

import Navigation from './Navigation';
import Bottom from './Bottom';

import './Menu.modules.scss';

type Props = {
  className?: string;
};

const Menu: React.FC<Props> = ({ className }) => {
  return (
    <div styleName="menu" className={className}>
      <Navigation styleName="menu__navigation" />
      <Bottom />
    </div>
  );
};

export default observer(Menu);
